import React, { useEffect, useState, useRef } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import SimpleBackdrop from "utils/general";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { MultiSelect } from "primereact/multiselect";
import { OverlayPanel } from "primereact/overlaypanel";
import _ from "lodash";
import { SelectButton } from "primereact/selectbutton";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import * as ExcelJS from "exceljs";
import FileSaver from "file-saver";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";

const filterOptions = ["Today", "7 Days", "30 Days"];

const limitTypeList = [
  { label: "Low Limit", value: "LowLimit" },
  { label: "Ideal Limit", value: "IdealLimit" },
  { label: "High Limit", value: "HighLimit" },
];

const RegularityIrregularityReport = (props) => {
  const initialFilterState = {
    FilterDate: "",
    FromDate: [new Date(), new Date()],
    Item: [],
    LimitType: "IdealLimit",
  };
  const actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  const [
    regularityIrregularityReportList,
    setRegularityIrregularityReportList,
  ] = useState([]);
  const [userId, setUserId] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [
    filteredRegularityIrregularityReportList,
    setFilteredRegularityIrregularityReportList,
  ] = useState([]);

  const [itemList, setItemList] = useState([]);
  const [filterData, setFilterData] = useState(initialFilterState);
  const [showCalendar, setShowCalendar] = useState(false);
  const [tempFromDate, setTempFromDate] = useState(initialFilterState.FromDate);

  const [userPageAccess, setUserPageAccess] = useState([]);

  const op = useRef(null);
  const summaryOp = useRef(null);
  const [showIdealPrompt, setShowIdealPrompt] = useState(false);
  const [idealDays, setIdealDays] = useState(30);

  useEffect(() => {
    if (op.current) {
      const patcher = (methodName) => {
        const originalMethod = op.current[methodName];
        if (originalMethod) {
          op.current[methodName] = (event) => {
            // Check if the click target is no longer in the DOM.
            // This happens with the calendar month/year navigation arrows,
            // which are removed on click, causing a false "outside" click detection.
            if (event.target && !document.body.contains(event.target)) {
              return false; // This was an inside click on a removed element.
            }
            // Proceed with the original logic.
            return originalMethod.call(op.current, event);
          };
        }
      };
      patcher("isOutsideClicked");
      patcher("hasOutsideClicked");
    }
  }, []);

  useEffect(() => {
    let token = localStorage.getItem("Token");
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let userPageAccess = localStorage.getItem("PageAccess");
    setUserPageAccess(userPageAccess);
    setUserId(data);
    getItemList(data);
  }, []);

  useEffect(() => {
    if (!filterData.FilterDate) return;

    const today = moment();
    let range = null;

    switch (filterData.FilterDate) {
      case "Today":
        range = [today.startOf("day").toDate(), today.endOf("day").toDate()];
        break;
      case "7 Days":
        range = [
          moment()
            .subtract(6, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      case "30 Days":
        range = [
          moment()
            .subtract(29, "days")
            .startOf("day")
            .toDate(),
          today.endOf("day").toDate(),
        ];
        break;
      default:
        range = null;
    }

    if (range) {
      setFilterData((prevState) => ({
        ...prevState,
        FromDate: range,
      }));
    }
  }, [filterData.FilterDate]);

  const getItemList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetItemMasterList, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter(
            (x) => x.UserId !== "Admin",
          ).map((item) => ({
            label: item.label || item.Item,
            value: item.value || item._id,
          }));
          setItemList(filterArry);
        }
      })
      .catch((err) => {});
  };

  const GetRegularityIrregularityReport = async (UserId, filter) => {
    let tempFilter = filter || filterData;
    Loader.show();
    if (validate()) {
      try {
        let params = {
          UserId: UserId,
          Filters: tempFilter,
        };
        await api
          .post(APIConstant.path.GetRegularityIrregularityReport, params)
          .then(async (res) => {
            if (res.Success === 1) {
              Loader.hide();
              setRegularityIrregularityReportList(res.Data);
              setFilteredRegularityIrregularityReportList(res.Data);
              op.current.hide();
            } else {
              Loader.hide();
              setRegularityIrregularityReportList([]);
              setFilteredRegularityIrregularityReportList([]);
              op.current.hide();
            }
          })
          .catch((err) => {
            console.log(err);
            Loader.hide();
          });
      } catch (err) {
        console.error(err);
        Loader.hide();
      }
    } else {
      Loader.hide();
    }
  };

  const validate = () => {
    let isValid = true;

    return isValid;
  };

  const handleReset = (e) => {
    op.current.hide();
    GetRegularityIrregularityReport(userId, initialFilterState);
  };

  const handleGlobalFilter = (e) => {
    setGlobalFilter(e.target.value);
    if (regularityIrregularityReportList.length) {
      let filteredRegularityIrregularityReportList = regularityIrregularityReportList;
      if (e.target.value) {
        filteredRegularityIrregularityReportList = filteredRegularityIrregularityReportList.filter(
          (x) => {
            return (
              x.ItemName.toLowerCase().indexOf(e.target.value.toLowerCase()) !==
              -1
            );
          },
        );
        setFilteredRegularityIrregularityReportList(
          filteredRegularityIrregularityReportList,
        );
      }

      setFilteredRegularityIrregularityReportList(
        filteredRegularityIrregularityReportList,
      );
    }
  };

  const getDateRange = () => {
    const { FilterDate, FromDate } = filterData;
    let startDate, endDate;

    if (FilterDate) {
      const today = moment().startOf("day");

      switch (FilterDate) {
        case "Today":
          startDate = today.clone();
          endDate = today.clone().endOf("day");
          break;
        case "7 Days":
          startDate = today
            .clone()
            .subtract(6, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        case "30 Days":
          startDate = today
            .clone()
            .subtract(29, "days")
            .startOf("day");
          endDate = today.clone().endOf("day");
          break;
        default:
          startDate = today.clone();
          endDate = today.clone().endOf("day");
      }
    } else {
      startDate = FromDate[0]
        ? moment(FromDate[0]).startOf("day")
        : moment().startOf("day");
      endDate = FromDate[1]
        ? moment(FromDate[1]).endOf("day")
        : moment().endOf("day");
    }

    const totalDays = endDate.diff(startDate, "days") + 1;
    const dateRangeText = `From ${startDate.format(
      "DD-MMM-YYYY",
    )} to ${endDate.format("DD-MMM-YYYY")}`;

    return { startDate, endDate, totalDays, dateRangeText };
  };

  const exportToExcel = async () => {
    if (filteredRegularityIrregularityReportList.length) {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet(
          "Regularity Irregularity Report",
        );

        const columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Date", field: "Date" },
          { header: "Product Code", field: "ItemCode" },
          { header: "Product Name", field: "ProductName" },
          {
            header: "Expected Per Month Inward",
            field: "ExpectedPerMonthInward",
          },
          { header: "Expected Per Day Inward", field: "ExpectedPerDayInward" },
          { header: "Range", field: "Range" },
          {
            header: "Expected Inward For Date Range",
            field: "ExpectedInwardForDateRange",
          },
          { header: "Total Inward", field: "TotalInward" },
          { header: "Per Day Inward", field: "PerDayInward" },
          { header: "Regularity Status (Inward)", field: "InwardRegularity" },
          { header: "Total Outward", field: "TotalOutward" },
          { header: "Per Day Outward", field: "PerDayOutward" },
          { header: "Regularity Status (Outward)", field: "OutwardRegularity" },
          { header: "Stock", field: "Stock" },
          {
            header: "Stock Availability (Days)",
            field: "StockAvailabilityDays",
          },
          { header: "Per Day Difference", field: "PerDayDifference" },
          {
            header: "As Per Current Flow (Days)",
            field: "DaysAsPerCurrentFlow",
          },
          { header: "Target", field: "ThisMonthTarget" },
          { header: "Per Day Increase", field: "PerDayIncrease" },
          { header: "Investment/Saving", field: "InvestmentOrSaving" },
        ];

        // Set column widths and keys
        worksheet.columns = columns.map((col) => ({
          key: col.field,
          width: col.header.length < 20 ? 20 : col.header.length + 5,
        }));

        const { dateRangeText } = getDateRange();
        const getLabels = (selectedValues, masterList) => {
          if (!selectedValues || selectedValues.length === 0) return "All";
          return selectedValues
            .map((val) => {
              const found = masterList.find((item) => item.value === val);
              return found ? found.label || found.Name : val;
            })
            .join(", ");
        };

        const filterStrings = [
          `Date: ${dateRangeText}`,
          `Items: ${getLabels(filterData.Item, itemList)}`,
          `Limit Type: ${limitTypeList.find(
            (l) => l.value === filterData.LimitType,
          )?.label ||
            filterData.LimitType ||
            "None"}`,
        ];

        // Metadata rows
        worksheet.addRow([
          "Report Name",
          "Regularity Irregularity Report",
        ]).font = {
          bold: true,
          size: 14,
        };
        worksheet.addRow(["Filter", filterStrings.join(" | ")]).font = {
          bold: true,
        };
        worksheet.addRow([
          "Generated On",
          moment().format("DD-MMM-YYYY HH:mm"),
        ]).font = { bold: true };
        worksheet.addRow([]); // Blank row row 4

        // Add Header Row (Row 5)
        worksheet.addRow(columns.map((col) => col.header)).font = {
          bold: true,
        };

        // Totals (optional: only for numeric fields)
        let totalInward = 0;
        let totalOutward = 0;
        let totalStock = 0;
        let totalTarget = 0;
        let totalInvestmentSaving = 0;

        filteredRegularityIrregularityReportList.forEach((item, index) => {
          const row = {};
          columns.forEach((col) => {
            row[col.field] =
              col.field === "Index" ? index + 1 : item[col.field] || "";
          });

          totalInward += parseFloat(item.TotalInward) || 0;
          totalOutward += parseFloat(item.TotalOutward) || 0;
          totalStock += parseFloat(item.Stock) || 0;
          totalTarget += parseFloat(item.ThisMonthTarget) || 0;

          const inv = parseFloat(
            item.InvestmentOrSaving?.replace(/[^\d.-]/g, ""),
          );
          totalInvestmentSaving += isNaN(inv) ? 0 : inv;

          worksheet.addRow(row);
        });

        worksheet.addRow([]);

        const totalRow = {};
        columns.forEach((col) => {
          switch (col.field) {
            case "TotalInward":
              totalRow[col.field] = totalInward;
              break;
            case "TotalOutward":
              totalRow[col.field] = totalOutward;
              break;
            case "Stock":
              totalRow[col.field] = totalStock;
              break;
            case "ThisMonthTarget":
              totalRow[col.field] = totalTarget;
              break;
            case "InvestmentOrSaving":
              totalRow[col.field] =
                totalInvestmentSaving >= 0
                  ? `+${totalInvestmentSaving.toFixed(2)}`
                  : `-${Math.abs(totalInvestmentSaving).toFixed(2)}`;
              break;
            default:
              totalRow[col.field] = "";
          }
        });

        worksheet.addRow(totalRow).font = { bold: true };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, `Regularity_Irregularity_Report.xlsx`);
      } catch (error) {
        console.error("Error exporting Regularity Irregularity Report:", error);
      }
    }
  };

  const exportToIdealExcel = async (days) => {
    if (filteredRegularityIrregularityReportList.length) {
      try {
        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet("Ideal Report");

        const columns = [
          { header: "Sr.No", field: "Index" },
          { header: "Product Name", field: "ProductName" },
          { header: "Total Inward", field: "TotalInward" },
          { header: "Per Day Inward", field: "PerDayInward" },
          { header: "Total Outward", field: "TotalOutward" },
          { header: "Per Day Outward", field: "PerDayOutward" },
          { header: "Stock", field: "Stock" },
          { header: "Stock Availability (Days)", field: "StockAvailabilityDays" },
          { header: `Ideal (${days})`, field: "IdealValue" },
        ];

        // Set column widths and keys
        worksheet.columns = columns.map((col) => ({
          key: col.field,
          width: col.header.length < 20 ? 20 : col.header.length + 5,
        }));

        const { dateRangeText } = getDateRange();
        const getLabels = (selectedValues, masterList) => {
          if (!selectedValues || selectedValues.length === 0) return "All";
          return selectedValues
            .map((val) => {
              const found = masterList.find((item) => item.value === val);
              return found ? found.label || found.Name : val;
            })
            .join(", ");
        };

        const filterStrings = [
          `Date: ${dateRangeText}`,
          `Items: ${getLabels(filterData.Item, itemList)}`,
          `Limit Type: ${limitTypeList.find(
            (l) => l.value === filterData.LimitType,
          )?.label ||
            filterData.LimitType ||
            "None"}`,
          `Ideal Days: ${days}`,
        ];

        // Metadata rows
        worksheet.addRow([
          "Report Name",
          "Ideal Report",
        ]).font = {
          bold: true,
          size: 14,
        };
        worksheet.addRow(["Filter", filterStrings.join(" | ")]).font = {
          bold: true,
        };
        worksheet.addRow([
          "Generated On",
          moment().format("DD-MMM-YYYY HH:mm"),
        ]).font = { bold: true };
        worksheet.addRow([]); // Blank row

        // Add Header Row
        worksheet.addRow(columns.map((col) => col.header)).font = {
          bold: true,
        };

        // Totals
        let totalInward = 0;
        let totalOutward = 0;
        let totalStock = 0;
        let totalIdeal = 0;

        filteredRegularityIrregularityReportList.forEach((item, index) => {
          const row = {};
          
          const perDayOutward = parseFloat(item.PerDayOutward) || 0;
          let stockAvailability = item.StockAvailabilityDays;
          if (perDayOutward === 0) {
            stockAvailability = "-";
          }

          const stock = parseFloat(item.Stock) || 0;
          const idealVal = parseFloat((perDayOutward * days - stock).toFixed(2));

          columns.forEach((col) => {
            if (col.field === "Index") {
              row[col.field] = index + 1;
            } else if (col.field === "IdealValue") {
              row[col.field] = idealVal;
            } else if (col.field === "StockAvailabilityDays") {
              row[col.field] = stockAvailability;
            } else {
              row[col.field] = item[col.field] || (item[col.field] === 0 ? 0 : "");
            }
          });

          totalInward += parseFloat(item.TotalInward) || 0;
          totalOutward += parseFloat(item.TotalOutward) || 0;
          totalStock += parseFloat(item.Stock) || 0;
          totalIdeal += idealVal;

          worksheet.addRow(row);
        });

        worksheet.addRow([]);

        const totalRow = {};
        columns.forEach((col) => {
          switch (col.field) {
            case "TotalInward":
              totalRow[col.field] = totalInward;
              break;
            case "TotalOutward":
              totalRow[col.field] = totalOutward;
              break;
            case "Stock":
              totalRow[col.field] = totalStock;
              break;
            case "IdealValue":
              totalRow[col.field] = parseFloat(totalIdeal.toFixed(2));
              break;
            default:
              totalRow[col.field] = "";
          }
        });

        worksheet.addRow(totalRow).font = { bold: true };

        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        FileSaver.saveAs(blob, `Ideal_Report_${days}_Days.xlsx`);
      } catch (error) {
        console.error("Error exporting Ideal Report:", error);
      }
    }
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      {loading === true ? (
        <div className="loading">
          <SimpleBackdrop />
        </div>
      ) : null}
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-upload"></i>
          <h2>Regualarity Irregularity Report</h2>
        </div>

        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              type="search"
              onChange={(e) => handleGlobalFilter(e)}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter ? <i className="icon-search"></i> : null}
          </div>

          <div
            className="e-add-btn"
            onClick={(e) => {
              exportToExcel();
            }}
          >
            <i className="pi pi-file-excel"></i>
          </div>

          <div
            className="e-add-btn"
            onClick={(e) => {
              summaryOp.current.toggle(e);
            }}
          >
            <span style={{ marginRight: "5px" }}>Summary</span>
          </div>

          <OverlayPanel
            ref={summaryOp}
            style={{ width: "150px" }}
          >
            <div className="p-menu p-component" style={{ border: 'none', padding: '0' }}>
              <ul className="p-menu-list" role="menu" style={{ margin: 0, padding: 0, listStyle: 'none' }}>
                <li className="p-menuitem" role="none" style={{ margin: 0 }}>
                  <span
                    role="menuitem"
                    className="p-menuitem-link"
                    onClick={() => {
                      summaryOp.current.hide();
                      setShowIdealPrompt(true);
                    }}
                    style={{
                      cursor: "pointer",
                      padding: "8px 12px",
                      display: "block",
                      color: "#333",
                      fontSize: "0.9rem",
                      fontWeight: "500",
                      transition: "background-color 0.2s"
                    }}
                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f4f4f4'}
                    onMouseLeave={(e) => e.target.style.backgroundColor = 'transparent'}
                  >
                    Ideal Report
                  </span>
                </li>
              </ul>
            </div>
          </OverlayPanel>

          <div className="p-position-relative">
            <Button
              onClick={(e) => {
                op.current.toggle(e);
              }}
              icon="icon-filter"
              rounded
              className="wb-search-btn p-ml-2"
            />

            {/* <button onClick={generatePDF}>Export PDF</button> */}
            <div className="header-bar">
              <div className="right-nav-buttons p-d-flex">
                <div>
                  <div className="noti-dropdown-outer">
                    <OverlayPanel
                      ref={op}
                      style={{ width: 500 }}
                      className="wayment-slip-filter"
                    >
                      <div>
                        <div role="menu">
                          <div className="p-grid p-p-2 trip-filter-box">
                            <div className="p-col-12  p-md-12 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">
                                    Select Date
                                  </label>
                                  <div className="p-d-flex p-ai-center">
                                    <SelectButton
                                      className="wb-filter-dt"
                                      value={filterData.FilterDate}
                                      onChange={(e) => {
                                        setFilterData((prevState) => ({
                                          ...prevState,
                                          FilterDate: e.value,
                                          FromDate: null,
                                        }));
                                      }}
                                      options={filterOptions}
                                    />
                                    <div className="custom-date-picker-wrapper p-mt-2 p-position-relative">
                                      <div
                                        className="p-inputgroup"
                                        onClick={() => {
                                          if (!showCalendar) {
                                            setTempFromDate(
                                              filterData.FromDate || [
                                                new Date(),
                                                new Date(),
                                              ],
                                            );
                                          }
                                          setShowCalendar(!showCalendar);
                                        }}
                                        style={{ cursor: "pointer" }}
                                      >
                                        <InputText
                                          readOnly
                                          style={{
                                            cursor: "pointer",
                                            height: "40px",
                                            backgroundColor: "#fff",
                                          }}
                                          placeholder="Start Date - End Date"
                                          value={
                                            Array.isArray(
                                              filterData.FromDate,
                                            ) && filterData.FromDate[0]
                                              ? `${moment(
                                                  filterData.FromDate[0],
                                                ).format("DD/MM/YYYY")} - ${
                                                  filterData.FromDate[1]
                                                    ? moment(
                                                        filterData.FromDate[1],
                                                      ).format("DD/MM/YYYY")
                                                    : ""
                                                }`
                                              : filterData.FromDate &&
                                                !Array.isArray(
                                                  filterData.FromDate,
                                                )
                                              ? moment(
                                                  filterData.FromDate,
                                                ).format("DD/MM/YYYY")
                                              : ""
                                          }
                                        />
                                        <Button
                                          type="button"
                                          icon="pi pi-calendar"
                                          style={{ height: "40px" }}
                                        />
                                      </div>
                                      {showCalendar && (
                                        <div
                                          className="p-p-2 p-mt-1"
                                          style={{
                                            position: "absolute",
                                            zIndex: 1000,
                                            top: "100%",
                                            right: 0,
                                            border: "1px solid #ced4da",
                                            borderRadius: "4px",
                                            backgroundColor: "#ffffff",
                                            width: "325px",
                                            boxShadow:
                                              "0 4px 6px rgba(0, 0, 0, 0.1)",
                                          }}
                                        >
                                          <Calendar
                                            inline
                                            selectionMode="range"
                                            value={tempFromDate}
                                            onChange={(e) =>
                                              setTempFromDate(e.value)
                                            }
                                          />
                                          <div
                                            className="p-d-flex p-jc-end p-mt-2 p-pt-2"
                                            style={{
                                              borderTop: "1px solid #ced4da",
                                            }}
                                          >
                                            <Button
                                              type="button"
                                              label="Cancel"
                                              className="p-button-text p-button-secondary p-mr-2"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setTempFromDate(
                                                  filterData.FromDate,
                                                );
                                                setTimeout(
                                                  () => setShowCalendar(false),
                                                  10,
                                                );
                                              }}
                                            />
                                            <Button
                                              type="button"
                                              label="OK"
                                              className="primary-btn"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setFilterData((prevState) => ({
                                                  ...prevState,
                                                  FilterDate: null,
                                                  FromDate: tempFromDate,
                                                }));
                                                setTimeout(
                                                  () => setShowCalendar(false),
                                                  10,
                                                );
                                              }}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">Items</label>
                                  <MultiSelect
                                    className="p-w-100 p-mt-1"
                                    value={filterData.Item}
                                    options={itemList}
                                    optionLabel="label"
                                    display="chip"
                                    fixedPlaceholder={true}
                                    placeholder="Select Items"
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        Item: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    filter
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="p-col-12  p-md-6 p-pt-2">
                              <div className="p-w-100 ">
                                <div className="custom-inputs">
                                  <label htmlFor="estimationtime">
                                    Limit Type
                                  </label>

                                  <Dropdown
                                    className="p-w-100"
                                    inputId="limit"
                                    placeholder="Limit"
                                    value={filterData.LimitType}
                                    onChange={(e) => {
                                      setFilterData((prevState) => ({
                                        ...prevState,
                                        LimitType: e?.value,
                                      }));
                                      e.stopPropagation();
                                    }}
                                    options={limitTypeList}
                                    optionLabel="label"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="noti-footer">
                          <div className="p-d-flex p-ml-2 p-mb-1">
                            <Button
                              className="primary-btn1"
                              onClick={(e) => {
                                handleReset(e);
                              }}
                            >
                              Reset
                            </Button>
                            <Button
                              className="primary-btn p-ml-2"
                              onClick={() =>
                                GetRegularityIrregularityReport(userId)
                              }
                            >
                              Filter
                            </Button>
                          </div>
                        </div>
                      </div>
                    </OverlayPanel>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div className="export-custom-large-wb-table">
        <DataTable
          className="main-table table-td"
          value={filteredRegularityIrregularityReportList}
          responsiveLayout="scroll"
          totalRecords={filteredRegularityIrregularityReportList.length}
          emptyMessage="No records found"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
        >
          <Column
            field="Index"
            header="Sr.No"
            body={actionBodyTemplateSrNo}
            style={{ width: "6%" }}
          ></Column>

          <Column field="Date" header="Date" style={{ width: "10%" }}></Column>
          <Column
            field="ItemCode"
            header="Product Code"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ProductName"
            header="Product Name"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ExpectedPerMonthInward"
            header="Expected Per Month Inward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ExpectedPerDayInward"
            header="Expected Per Day Inward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="Range"
            header="Range"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ExpectedInwardForDateRange"
            header="Expected Inward For Date Range"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="TotalInward"
            header="Total Inward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="PerDayInward"
            header="Per Day Inward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="InwardRegularity"
            header="Regularity Status"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="TotalOutward"
            header="Total Outward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="PerDayOutward"
            header="Per Day Outward"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="OutwardRegularity"
            header="Regularity Status"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="Stock"
            header="Stock"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="StockAvailabilityDays"
            header="Stock Availability (Days) "
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="PerDayDifference"
            header="Per Day Difference "
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="DaysAsPerCurrentFlow"
            header="As Per Current Inward and Outward (Days)"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="ThisMonthTarget"
            header="Target"
            style={{ width: "10%" }}
          ></Column>
          <Column
            field="PerDayIncrease"
            header="Per Day Increase"
            style={{ width: "10%" }}
            body={(rowData) => {
              const color =
                rowData.PerDayIncreaseDirection === "up"
                  ? "green"
                  : rowData.PerDayIncreaseDirection === "down"
                  ? "red"
                  : "gray";
              const icon =
                rowData.PerDayIncreaseDirection === "up"
                  ? "↑"
                  : rowData.PerDayIncreaseDirection === "down"
                  ? "↓"
                  : "→";
              return (
                <span style={{ color }}>
                  {icon} {rowData.PerDayIncrease}
                </span>
              );
            }}
          />

          <Column
            field="InvestmentOrSaving"
            header="Investment/Saving"
            style={{ width: "10%" }}
            body={(rowData) => (
              <span
                style={{
                  color: rowData.InvestmentOrSaving.startsWith("+")
                    ? "green"
                    : "red",
                }}
              >
                {rowData.InvestmentOrSaving}
              </span>
            )}
          />
        </DataTable>
      </div>

      <Dialog
        open={showIdealPrompt}
        onClose={() => setShowIdealPrompt(false)}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Ideal Report Configuration</div>
          <div
            className="dialog-close"
            onClick={() => setShowIdealPrompt(false)}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <GridContainer>
            <GridItem md={12}>
              <TextField
                autoFocus
                margin="dense"
                name="idealDays"
                label="Number of Days*"
                type="number"
                value={idealDays}
                onChange={(e) => {
                  const val = parseInt(e.target.value);
                  setIdealDays(isNaN(val) ? "" : val);
                }}
                fullWidth
              />
            </GridItem>
          </GridContainer>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => setShowIdealPrompt(false)}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={() => {
              setShowIdealPrompt(false);
              const daysVal = parseInt(idealDays);
              exportToIdealExcel(isNaN(daysVal) ? 30 : daysVal);
            }}
            type="submit"
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RegularityIrregularityReport;
